var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-danger"},[_c('div',{staticClass:"hero-body"},[_c('p',{staticClass:"title"},[_vm._v(" Debes completar los siguientes campos ")]),_vm._l((_vm.errores),function(error,index){return _c('p',{key:index,staticClass:"subtitle"},[_vm._v(" "+_vm._s(error)+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }